// Third-party
import React, { useState } from 'react';
import classNames from 'classnames';

// Components
import Tooltip from './Tooltip';
import Icon from '../common/Icon';

type Props = {
  icon?: string;
  message: string;
  title?: string;
  list?: Array<any>;
  place?: 'bottom' | 'top' | 'left' | 'right';
  dark?: boolean;
  className?: string;
  overridePosition?: Function;
};

const InfoTooltip = ({ className, ...props }: Props) => {
  const [hovered, setHovered] = useState(false);

  return (
    <Tooltip
      className={classNames('info-tooltip tooltip-icon custom-tooltip-v2', className, { dark: props.dark })}
      icon={props.icon ?? 'icon-ds-info'}
      {...props}
    >
      <Icon
        type="ds-info"
        margin="0 0 0 4px"
        size={13}
        color="var(--icon-secondary)"
        className={hovered ? 'show' : undefined}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        tooltip
      />
    </Tooltip>
  );
};

export default InfoTooltip;
